/* Outdoor Water Solutions custom storefront behavior. */
(() => {
  const ENABLE_MOBILE_EXPAND_BUTTONS = false;
  const mobileExpandBreakpoint = window.matchMedia('(max-width: 749px)');

  const optionMap = [
    ['.pivot-bearing-link', 'Pivot-Bearing', 'Pivot Bearing', '/products/ows-windmill-pivot-bearing-smooth-low-wind-performance'],
    ['.alligator-head-link', 'Alligator-Head', 'Floating Alligator Head', '/products/gator-floating-alligator-head-decoy'],
    ['.aRequired-Aeration-Essential', 'Membrane ', 'Membrane ', '/products/single-disc-diffuser-self-sinking-base'],
    ['.aRequired-Aeration-Essential', 'Membranes + Valve ', 'Membranes + Valve ', '/products/windmill-single-disc-diffuser-pack'],
    ['.aRequired-Aeration-Essential', 'Air Stones + Valve', 'Air Stones + Valve ', '/products/aerator-double-airstone-diffuser-kit'],
    ['.aRequired-Aeration-Essential', 'Airstone', 'Airstone', '/products/airstone-diffuser-kit'],
    ['.anAirline-Add', '100ft', '100', '/products/pond-aerator-airline-tubing-weighted?variant=43253064597527'],
    ['.aDecoys', 'Duck Decoy', 'Duck', '/products/pond-aerator-diffuser-accessory-duck-decoy'],
    ['.aDecoys', 'Gator Decoy', 'Gator', '/products/gator-floating-alligator-head-decoy'],
    ['.aDecoys', 'Ducks', 'Duck Decoys', '/products/pond-aerator-diffuser-accessory-duck-decoy?variant=45180577415191'],
    ['.aDecoys', 'Gators', 'Gator Decoys', '/products/gator-floating-alligator-head-decoy?variant=45180578496535'],
    ['.aStabilityAnchor', 'Anchor Kit', 'Anchor Kit', '/products/wood-windmill-anchor-kit-storm-proof-stability'],
    ['.aControlpanelz', 'Panel for 3 HP', 'Panel for 3 HP', '/products/control-panel-for-ows-fountains?variant=45118228267031'],
    ['.aControlpanelz', 'Panel for 5 HP', 'Panel for 5 HP', '/products/control-panel-for-ows-fountains?variant=45118228299799'],
    ['.aControlpanelz', 'Panel for 7.5 HP', 'Panel for 7.5 HP', '/products/control-panel-for-ows-fountains?variant=45118228332567'],
    ['.combokit-IA-SA1', 'Add Conversion Kit', 'Add Conversion Kit', '/products/ows-iceaway-to-surface-aerator-conversion-kit'],
    ['.combokit-IA-SA2', 'Add Conversion Chain', 'Add Conversion Chain', '/products/ows-surface-aerator-deicer-conversion-kit'],
    ['.combokit-SA-IA2', 'Add Conversion Kit', 'Add Conversion Kit', '/products/ows-surface-aerator-deicer-conversion-kit'],
    ['.propguard-IA', 'Prop-Guard', 'Prop-Guard', '/products/motor-prop-guard'],
  ];

  function initializeLookbookHotspots() {
    const hotspots = document.querySelectorAll('lookbook-icon');

    hotspots.forEach((hotspot) => {
      const pin = hotspot.querySelector('.lookbook-icon__pin');
      if (!pin || pin.dataset.owsBound === 'true') return;

      pin.dataset.owsBound = 'true';

      pin.addEventListener('click', (event) => {
        event.stopPropagation();

        const shouldOpen = !hotspot.classList.contains('is-active');

        hotspots.forEach((item) => item.classList.remove('is-active'));

        if (shouldOpen) {
          hotspot.classList.add('is-active');
        }
      });
    });
  }

  function initializeWindmillQuizLink() {
    const target = document.querySelector(
      '#shopify-section-template--24369093050391__windmill_quiz_fAkLQQ'
    );

    const link = document.querySelector(
      'a[href="#shopify-section-template--24369093050391__windmill_quiz_fAkLQQ"]'
    );

    if (!link || !target || link.dataset.owsBound === 'true') return;

    link.dataset.owsBound = 'true';

    link.addEventListener('click', (event) => {
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    });
  }

  function initializeMobileExpandButtons() {
    document.querySelectorAll('.mobile-expand-button').forEach((button) => {
      const text = button.previousElementSibling;
      if (!text) return;

      if (
        !ENABLE_MOBILE_EXPAND_BUTTONS &&
        mobileExpandBreakpoint.matches
      ) {
        button.hidden = true;
        button.setAttribute('aria-hidden', 'true');
        text.classList.add('expanded');
        return;
      }

      button.hidden = false;
      button.removeAttribute('aria-hidden');

      if (button.dataset.owsBound === 'true') return;

      button.dataset.owsBound = 'true';

      button.addEventListener('click', () => {
        text.classList.toggle('expanded');

        const isExpanded = text.classList.contains('expanded');

        button.textContent = isExpanded ? 'View Less' : 'View More';
        button.setAttribute('aria-expanded', String(isExpanded));
      });
    });
  }

  function transformGloboLinks() {
    optionMap.forEach(([selector, findText, replacement, url], index) => {
      document
        .querySelectorAll(
          `${selector} label, ${selector} .gpo-option-value-label`
        )
        .forEach((label) => {
          if (
            !label.innerHTML.includes(findText) ||
            label.querySelector('.ows-clickable-target')
          ) {
            return;
          }

          label.innerHTML = label.innerHTML.replace(
            findText,
            `<span class="ows-clickable-target" data-link-idx="${index}" role="link" tabindex="0">${replacement}</span>`
          );
        });
    });
  }

  function patchProductAccordionBehavior() {
    const patchAccordion = () => {
      const AccordionGroup = customElements.get('accordion-group');

      if (
        !AccordionGroup ||
        AccordionGroup.prototype.owsProductAccordionPatchApplied
      ) {
        return;
      }

      const originalHandleAfterToggle =
        AccordionGroup.prototype.handleAfterToggle;

      AccordionGroup.prototype.handleAfterToggle = function () {
        if (this.closest('.product__blocks')) {
          return;
        }

        return originalHandleAfterToggle.call(this);
      };

      AccordionGroup.prototype.owsProductAccordionPatchApplied = true;
    };

    if (customElements.get('accordion-group')) {
      patchAccordion();
    } else {
      customElements
        .whenDefined('accordion-group')
        .then(patchAccordion);
    }
  }
  function preserveProductAccordionPosition(event) {
    const summary = event.target.closest(
      '.product__info-container .product__blocks details > summary'
    );

    if (!summary) return;

    const initialTop = summary.getBoundingClientRect().top;
    const startedAt = performance.now();

    const holdSummaryPosition = () => {
      if (!summary.isConnected) return;

      const currentTop = summary.getBoundingClientRect().top;
      const offset = currentTop - initialTop;

      if (Math.abs(offset) > 0.5) {
        window.scrollBy(0, offset);
      }

      if (performance.now() - startedAt < 350) {
        window.requestAnimationFrame(holdSummaryPosition);
      }
    };

    window.requestAnimationFrame(holdSummaryPosition);
  }

  function initializeCalculator(event) {
    if (!event.target.closest('#SF_CALC_BTN')) return false;

    const lengthInput = document.getElementById('L_FEET_APP');
    const widthInput = document.getElementById('W_FEET_APP');
    const resultsBox = document.getElementById('RESULTS_BOX');
    const unitResult = document.getElementById('UNIT_RESULT');
    const areaResult = document.getElementById('AREA_RESULT');

    if (
      !lengthInput ||
      !widthInput ||
      !resultsBox ||
      !unitResult ||
      !areaResult
    ) {
      return true;
    }

    const length = Number.parseFloat(lengthInput.value);
    const width = Number.parseFloat(widthInput.value);

    if (length > 0 && width > 0) {
      const area = length * width;
      const units = Math.ceil(area / 3000);

      unitResult.textContent =
        `${units}${units === 1 ? ' Unit' : ' Units'}`;

      areaResult.textContent =
        `${area.toLocaleString()} sq. ft. Total Area`;

      resultsBox.style.display = 'block';
    } else {
      window.alert('Please enter a valid length and width.');
    }

    return true;
  }

  function openOptionLink(optionLink) {
    const item = optionMap[Number(optionLink.dataset.linkIdx)];
    if (!item) return;

    window.open(item[3], '_blank', 'noopener');
  }

  function initializePage() {
    initializeLookbookHotspots();
    initializeWindmillQuizLink();
    initializeMobileExpandButtons();
    transformGloboLinks();
  }

  patchProductAccordionBehavior();
  document.addEventListener(
    'click',
    preserveProductAccordionPosition,
    true
  );
  let mutationTimer;

  const observer = new MutationObserver(() => {
    window.clearTimeout(mutationTimer);

    mutationTimer = window.setTimeout(initializePage, 75);
  });

  document.addEventListener('click', (event) => {
    document
      .querySelectorAll('lookbook-icon.is-active')
      .forEach((hotspot) => {
        if (!hotspot.contains(event.target)) {
          hotspot.classList.remove('is-active');
        }
      });

    if (initializeCalculator(event)) return;

    const optionLink = event.target.closest('.ows-clickable-target');
    if (!optionLink) return;

    event.preventDefault();
    event.stopPropagation();

    openOptionLink(optionLink);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const optionLink = event.target.closest('.ows-clickable-target');
    if (!optionLink) return;

    event.preventDefault();
    event.stopPropagation();

    openOptionLink(optionLink);
  });

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializePage,
      { once: true }
    );
  } else {
    initializePage();
  }

  mobileExpandBreakpoint.addEventListener(
    'change',
    initializeMobileExpandButtons
  );

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();